import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/free-solid-svg-icons';

interface ResetButtonProps {
    onClick: () => void;
}

const ResetButton: React.FC<ResetButtonProps> = ({ onClick }) => {
    const buttonClass = "bg-neutral-200 text-neutral-800 hover:bg-neutral-100 dark:bg-neutral-600 dark:text-neutral-300 dark:hover:bg-neutral-500";

    return (
        <button
            onClick={onClick}
            className={`px-3 h-8 rounded-lg transition-all duration-200 ${buttonClass}`}
            title="Reset to default"
        >
            <FontAwesomeIcon icon={faUndo} className="h-4 w-4" />
        </button>
    );
};

export default ResetButton;
